/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VendorImport } from './routes/vendor'
import { Route as TestPaymentImport } from './routes/test-payment'
import { Route as TermsImport } from './routes/terms'
import { Route as QueryImport } from './routes/query'
import { Route as PrivacyImport } from './routes/privacy'
import { Route as PolicyImport } from './routes/policy'
import { Route as GetStartedImport } from './routes/get-started'
import { Route as FormImport } from './routes/form'
import { Route as BuyerImport } from './routes/buyer'
import { Route as AuthImport } from './routes/_auth'
import { Route as IndexImport } from './routes/index'
import { Route as VendorSupportImport } from './routes/vendor/support'
import { Route as VendorNotificationsImport } from './routes/vendor/notifications'
import { Route as VendorHomeImport } from './routes/vendor/home'
import { Route as VendorDisputeImport } from './routes/vendor/dispute'
import { Route as BuyerSupportImport } from './routes/buyer/support'
import { Route as BuyerNotificationsImport } from './routes/buyer/notifications'
import { Route as BuyerHomeImport } from './routes/buyer/home'
import { Route as BuyerDisputeImport } from './routes/buyer/dispute'
import { Route as AuthVerifyEmailImport } from './routes/_auth/verify-email'
import { Route as AuthUserTypeImport } from './routes/_auth/user-type'
import { Route as AuthSignUpImport } from './routes/_auth/sign-up'
import { Route as AuthSignInImport } from './routes/_auth/sign-in'
import { Route as VendorStoreIndexImport } from './routes/vendor/store/index'
import { Route as VendorSettingsIndexImport } from './routes/vendor/settings/index'
import { Route as VendorOrdersIndexImport } from './routes/vendor/orders/index'
import { Route as VendorContractIndexImport } from './routes/vendor/contract/index'
import { Route as BuyerVendorIndexImport } from './routes/buyer/vendor/index'
import { Route as BuyerSettingsIndexImport } from './routes/buyer/settings/index'
import { Route as BuyerOrdersIndexImport } from './routes/buyer/orders/index'
import { Route as VendorStoreCreateImport } from './routes/vendor/store/create'
import { Route as VendorStoreProductidImport } from './routes/vendor/store/$productid'
import { Route as VendorOrdersOrderidImport } from './routes/vendor/orders/$orderid'
import { Route as VendorDisputeDisputeidImport } from './routes/vendor/dispute/$disputeid'
import { Route as VendorContractDropoffLocationImport } from './routes/vendor/contract/dropoff-location'
import { Route as VendorContractCreateImport } from './routes/vendor/contract/create'
import { Route as VendorContractCartImport } from './routes/vendor/contract/cart'
import { Route as BuyerVendorVendoridImport } from './routes/buyer/vendor/$vendorid'
import { Route as BuyerSettingsMyAccountImport } from './routes/buyer/settings/my-account'
import { Route as BuyerDisputeDisputeidImport } from './routes/buyer/dispute/$disputeid'
import { Route as VendorContractContractidIndexImport } from './routes/vendor/contract/$contractid/index'
import { Route as BuyerOrdersOrderidIndexImport } from './routes/buyer/orders/$orderid/index'
import { Route as VendorStoreEditProductidImport } from './routes/vendor/store/edit.$productid'
import { Route as VendorContractContractidEditImport } from './routes/vendor/contract/$contractid/edit'
import { Route as BuyerOrdersOrderidChatImport } from './routes/buyer/orders/$orderid/chat'

// Create Virtual Routes

const AuthForgotPasswordLazyImport = createFileRoute('/_auth/forgot-password')()

// Create/Update Routes

const VendorRoute = VendorImport.update({
  id: '/vendor',
  path: '/vendor',
  getParentRoute: () => rootRoute,
} as any)

const TestPaymentRoute = TestPaymentImport.update({
  id: '/test-payment',
  path: '/test-payment',
  getParentRoute: () => rootRoute,
} as any)

const TermsRoute = TermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRoute,
} as any)

const QueryRoute = QueryImport.update({
  id: '/query',
  path: '/query',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyRoute = PrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRoute,
} as any)

const PolicyRoute = PolicyImport.update({
  id: '/policy',
  path: '/policy',
  getParentRoute: () => rootRoute,
} as any)

const GetStartedRoute = GetStartedImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRoute,
} as any)

const FormRoute = FormImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => rootRoute,
} as any)

const BuyerRoute = BuyerImport.update({
  id: '/buyer',
  path: '/buyer',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordLazyRoute = AuthForgotPasswordLazyImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/forgot-password.lazy').then((d) => d.Route),
)

const VendorSupportRoute = VendorSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => VendorRoute,
} as any)

const VendorNotificationsRoute = VendorNotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => VendorRoute,
} as any)

const VendorHomeRoute = VendorHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => VendorRoute,
} as any)

const VendorDisputeRoute = VendorDisputeImport.update({
  id: '/dispute',
  path: '/dispute',
  getParentRoute: () => VendorRoute,
} as any)

const BuyerSupportRoute = BuyerSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerNotificationsRoute = BuyerNotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerHomeRoute = BuyerHomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerDisputeRoute = BuyerDisputeImport.update({
  id: '/dispute',
  path: '/dispute',
  getParentRoute: () => BuyerRoute,
} as any)

const AuthVerifyEmailRoute = AuthVerifyEmailImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)

const AuthUserTypeRoute = AuthUserTypeImport.update({
  id: '/user-type',
  path: '/user-type',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignUpRoute = AuthSignUpImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRoute,
} as any)

const AuthSignInRoute = AuthSignInImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)

const VendorStoreIndexRoute = VendorStoreIndexImport.update({
  id: '/store/',
  path: '/store/',
  getParentRoute: () => VendorRoute,
} as any)

const VendorSettingsIndexRoute = VendorSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => VendorRoute,
} as any)

const VendorOrdersIndexRoute = VendorOrdersIndexImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => VendorRoute,
} as any)

const VendorContractIndexRoute = VendorContractIndexImport.update({
  id: '/contract/',
  path: '/contract/',
  getParentRoute: () => VendorRoute,
} as any)

const BuyerVendorIndexRoute = BuyerVendorIndexImport.update({
  id: '/vendor/',
  path: '/vendor/',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerSettingsIndexRoute = BuyerSettingsIndexImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerOrdersIndexRoute = BuyerOrdersIndexImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => BuyerRoute,
} as any)

const VendorStoreCreateRoute = VendorStoreCreateImport.update({
  id: '/store/create',
  path: '/store/create',
  getParentRoute: () => VendorRoute,
} as any)

const VendorStoreProductidRoute = VendorStoreProductidImport.update({
  id: '/store/$productid',
  path: '/store/$productid',
  getParentRoute: () => VendorRoute,
} as any)

const VendorOrdersOrderidRoute = VendorOrdersOrderidImport.update({
  id: '/orders/$orderid',
  path: '/orders/$orderid',
  getParentRoute: () => VendorRoute,
} as any)

const VendorDisputeDisputeidRoute = VendorDisputeDisputeidImport.update({
  id: '/$disputeid',
  path: '/$disputeid',
  getParentRoute: () => VendorDisputeRoute,
} as any)

const VendorContractDropoffLocationRoute =
  VendorContractDropoffLocationImport.update({
    id: '/contract/dropoff-location',
    path: '/contract/dropoff-location',
    getParentRoute: () => VendorRoute,
  } as any)

const VendorContractCreateRoute = VendorContractCreateImport.update({
  id: '/contract/create',
  path: '/contract/create',
  getParentRoute: () => VendorRoute,
} as any)

const VendorContractCartRoute = VendorContractCartImport.update({
  id: '/contract/cart',
  path: '/contract/cart',
  getParentRoute: () => VendorRoute,
} as any)

const BuyerVendorVendoridRoute = BuyerVendorVendoridImport.update({
  id: '/vendor/$vendorid',
  path: '/vendor/$vendorid',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerSettingsMyAccountRoute = BuyerSettingsMyAccountImport.update({
  id: '/settings/my-account',
  path: '/settings/my-account',
  getParentRoute: () => BuyerRoute,
} as any)

const BuyerDisputeDisputeidRoute = BuyerDisputeDisputeidImport.update({
  id: '/$disputeid',
  path: '/$disputeid',
  getParentRoute: () => BuyerDisputeRoute,
} as any)

const VendorContractContractidIndexRoute =
  VendorContractContractidIndexImport.update({
    id: '/contract/$contractid/',
    path: '/contract/$contractid/',
    getParentRoute: () => VendorRoute,
  } as any)

const BuyerOrdersOrderidIndexRoute = BuyerOrdersOrderidIndexImport.update({
  id: '/orders/$orderid/',
  path: '/orders/$orderid/',
  getParentRoute: () => BuyerRoute,
} as any)

const VendorStoreEditProductidRoute = VendorStoreEditProductidImport.update({
  id: '/store/edit/$productid',
  path: '/store/edit/$productid',
  getParentRoute: () => VendorRoute,
} as any)

const VendorContractContractidEditRoute =
  VendorContractContractidEditImport.update({
    id: '/contract/$contractid/edit',
    path: '/contract/$contractid/edit',
    getParentRoute: () => VendorRoute,
  } as any)

const BuyerOrdersOrderidChatRoute = BuyerOrdersOrderidChatImport.update({
  id: '/orders/$orderid/chat',
  path: '/orders/$orderid/chat',
  getParentRoute: () => BuyerRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/buyer': {
      id: '/buyer'
      path: '/buyer'
      fullPath: '/buyer'
      preLoaderRoute: typeof BuyerImport
      parentRoute: typeof rootRoute
    }
    '/form': {
      id: '/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof FormImport
      parentRoute: typeof rootRoute
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedImport
      parentRoute: typeof rootRoute
    }
    '/policy': {
      id: '/policy'
      path: '/policy'
      fullPath: '/policy'
      preLoaderRoute: typeof PolicyImport
      parentRoute: typeof rootRoute
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyImport
      parentRoute: typeof rootRoute
    }
    '/query': {
      id: '/query'
      path: '/query'
      fullPath: '/query'
      preLoaderRoute: typeof QueryImport
      parentRoute: typeof rootRoute
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsImport
      parentRoute: typeof rootRoute
    }
    '/test-payment': {
      id: '/test-payment'
      path: '/test-payment'
      fullPath: '/test-payment'
      preLoaderRoute: typeof TestPaymentImport
      parentRoute: typeof rootRoute
    }
    '/vendor': {
      id: '/vendor'
      path: '/vendor'
      fullPath: '/vendor'
      preLoaderRoute: typeof VendorImport
      parentRoute: typeof rootRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInImport
      parentRoute: typeof AuthImport
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpImport
      parentRoute: typeof AuthImport
    }
    '/_auth/user-type': {
      id: '/_auth/user-type'
      path: '/user-type'
      fullPath: '/user-type'
      preLoaderRoute: typeof AuthUserTypeImport
      parentRoute: typeof AuthImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailImport
      parentRoute: typeof AuthImport
    }
    '/buyer/dispute': {
      id: '/buyer/dispute'
      path: '/dispute'
      fullPath: '/buyer/dispute'
      preLoaderRoute: typeof BuyerDisputeImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/home': {
      id: '/buyer/home'
      path: '/home'
      fullPath: '/buyer/home'
      preLoaderRoute: typeof BuyerHomeImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/notifications': {
      id: '/buyer/notifications'
      path: '/notifications'
      fullPath: '/buyer/notifications'
      preLoaderRoute: typeof BuyerNotificationsImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/support': {
      id: '/buyer/support'
      path: '/support'
      fullPath: '/buyer/support'
      preLoaderRoute: typeof BuyerSupportImport
      parentRoute: typeof BuyerImport
    }
    '/vendor/dispute': {
      id: '/vendor/dispute'
      path: '/dispute'
      fullPath: '/vendor/dispute'
      preLoaderRoute: typeof VendorDisputeImport
      parentRoute: typeof VendorImport
    }
    '/vendor/home': {
      id: '/vendor/home'
      path: '/home'
      fullPath: '/vendor/home'
      preLoaderRoute: typeof VendorHomeImport
      parentRoute: typeof VendorImport
    }
    '/vendor/notifications': {
      id: '/vendor/notifications'
      path: '/notifications'
      fullPath: '/vendor/notifications'
      preLoaderRoute: typeof VendorNotificationsImport
      parentRoute: typeof VendorImport
    }
    '/vendor/support': {
      id: '/vendor/support'
      path: '/support'
      fullPath: '/vendor/support'
      preLoaderRoute: typeof VendorSupportImport
      parentRoute: typeof VendorImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordLazyImport
      parentRoute: typeof AuthImport
    }
    '/buyer/dispute/$disputeid': {
      id: '/buyer/dispute/$disputeid'
      path: '/$disputeid'
      fullPath: '/buyer/dispute/$disputeid'
      preLoaderRoute: typeof BuyerDisputeDisputeidImport
      parentRoute: typeof BuyerDisputeImport
    }
    '/buyer/settings/my-account': {
      id: '/buyer/settings/my-account'
      path: '/settings/my-account'
      fullPath: '/buyer/settings/my-account'
      preLoaderRoute: typeof BuyerSettingsMyAccountImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/vendor/$vendorid': {
      id: '/buyer/vendor/$vendorid'
      path: '/vendor/$vendorid'
      fullPath: '/buyer/vendor/$vendorid'
      preLoaderRoute: typeof BuyerVendorVendoridImport
      parentRoute: typeof BuyerImport
    }
    '/vendor/contract/cart': {
      id: '/vendor/contract/cart'
      path: '/contract/cart'
      fullPath: '/vendor/contract/cart'
      preLoaderRoute: typeof VendorContractCartImport
      parentRoute: typeof VendorImport
    }
    '/vendor/contract/create': {
      id: '/vendor/contract/create'
      path: '/contract/create'
      fullPath: '/vendor/contract/create'
      preLoaderRoute: typeof VendorContractCreateImport
      parentRoute: typeof VendorImport
    }
    '/vendor/contract/dropoff-location': {
      id: '/vendor/contract/dropoff-location'
      path: '/contract/dropoff-location'
      fullPath: '/vendor/contract/dropoff-location'
      preLoaderRoute: typeof VendorContractDropoffLocationImport
      parentRoute: typeof VendorImport
    }
    '/vendor/dispute/$disputeid': {
      id: '/vendor/dispute/$disputeid'
      path: '/$disputeid'
      fullPath: '/vendor/dispute/$disputeid'
      preLoaderRoute: typeof VendorDisputeDisputeidImport
      parentRoute: typeof VendorDisputeImport
    }
    '/vendor/orders/$orderid': {
      id: '/vendor/orders/$orderid'
      path: '/orders/$orderid'
      fullPath: '/vendor/orders/$orderid'
      preLoaderRoute: typeof VendorOrdersOrderidImport
      parentRoute: typeof VendorImport
    }
    '/vendor/store/$productid': {
      id: '/vendor/store/$productid'
      path: '/store/$productid'
      fullPath: '/vendor/store/$productid'
      preLoaderRoute: typeof VendorStoreProductidImport
      parentRoute: typeof VendorImport
    }
    '/vendor/store/create': {
      id: '/vendor/store/create'
      path: '/store/create'
      fullPath: '/vendor/store/create'
      preLoaderRoute: typeof VendorStoreCreateImport
      parentRoute: typeof VendorImport
    }
    '/buyer/orders/': {
      id: '/buyer/orders/'
      path: '/orders'
      fullPath: '/buyer/orders'
      preLoaderRoute: typeof BuyerOrdersIndexImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/settings/': {
      id: '/buyer/settings/'
      path: '/settings'
      fullPath: '/buyer/settings'
      preLoaderRoute: typeof BuyerSettingsIndexImport
      parentRoute: typeof BuyerImport
    }
    '/buyer/vendor/': {
      id: '/buyer/vendor/'
      path: '/vendor'
      fullPath: '/buyer/vendor'
      preLoaderRoute: typeof BuyerVendorIndexImport
      parentRoute: typeof BuyerImport
    }
    '/vendor/contract/': {
      id: '/vendor/contract/'
      path: '/contract'
      fullPath: '/vendor/contract'
      preLoaderRoute: typeof VendorContractIndexImport
      parentRoute: typeof VendorImport
    }
    '/vendor/orders/': {
      id: '/vendor/orders/'
      path: '/orders'
      fullPath: '/vendor/orders'
      preLoaderRoute: typeof VendorOrdersIndexImport
      parentRoute: typeof VendorImport
    }
    '/vendor/settings/': {
      id: '/vendor/settings/'
      path: '/settings'
      fullPath: '/vendor/settings'
      preLoaderRoute: typeof VendorSettingsIndexImport
      parentRoute: typeof VendorImport
    }
    '/vendor/store/': {
      id: '/vendor/store/'
      path: '/store'
      fullPath: '/vendor/store'
      preLoaderRoute: typeof VendorStoreIndexImport
      parentRoute: typeof VendorImport
    }
    '/buyer/orders/$orderid/chat': {
      id: '/buyer/orders/$orderid/chat'
      path: '/orders/$orderid/chat'
      fullPath: '/buyer/orders/$orderid/chat'
      preLoaderRoute: typeof BuyerOrdersOrderidChatImport
      parentRoute: typeof BuyerImport
    }
    '/vendor/contract/$contractid/edit': {
      id: '/vendor/contract/$contractid/edit'
      path: '/contract/$contractid/edit'
      fullPath: '/vendor/contract/$contractid/edit'
      preLoaderRoute: typeof VendorContractContractidEditImport
      parentRoute: typeof VendorImport
    }
    '/vendor/store/edit/$productid': {
      id: '/vendor/store/edit/$productid'
      path: '/store/edit/$productid'
      fullPath: '/vendor/store/edit/$productid'
      preLoaderRoute: typeof VendorStoreEditProductidImport
      parentRoute: typeof VendorImport
    }
    '/buyer/orders/$orderid/': {
      id: '/buyer/orders/$orderid/'
      path: '/orders/$orderid'
      fullPath: '/buyer/orders/$orderid'
      preLoaderRoute: typeof BuyerOrdersOrderidIndexImport
      parentRoute: typeof BuyerImport
    }
    '/vendor/contract/$contractid/': {
      id: '/vendor/contract/$contractid/'
      path: '/contract/$contractid'
      fullPath: '/vendor/contract/$contractid'
      preLoaderRoute: typeof VendorContractContractidIndexImport
      parentRoute: typeof VendorImport
    }
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthUserTypeRoute: typeof AuthUserTypeRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthForgotPasswordLazyRoute: typeof AuthForgotPasswordLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthUserTypeRoute: AuthUserTypeRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthForgotPasswordLazyRoute: AuthForgotPasswordLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface BuyerDisputeRouteChildren {
  BuyerDisputeDisputeidRoute: typeof BuyerDisputeDisputeidRoute
}

const BuyerDisputeRouteChildren: BuyerDisputeRouteChildren = {
  BuyerDisputeDisputeidRoute: BuyerDisputeDisputeidRoute,
}

const BuyerDisputeRouteWithChildren = BuyerDisputeRoute._addFileChildren(
  BuyerDisputeRouteChildren,
)

interface BuyerRouteChildren {
  BuyerDisputeRoute: typeof BuyerDisputeRouteWithChildren
  BuyerHomeRoute: typeof BuyerHomeRoute
  BuyerNotificationsRoute: typeof BuyerNotificationsRoute
  BuyerSupportRoute: typeof BuyerSupportRoute
  BuyerSettingsMyAccountRoute: typeof BuyerSettingsMyAccountRoute
  BuyerVendorVendoridRoute: typeof BuyerVendorVendoridRoute
  BuyerOrdersIndexRoute: typeof BuyerOrdersIndexRoute
  BuyerSettingsIndexRoute: typeof BuyerSettingsIndexRoute
  BuyerVendorIndexRoute: typeof BuyerVendorIndexRoute
  BuyerOrdersOrderidChatRoute: typeof BuyerOrdersOrderidChatRoute
  BuyerOrdersOrderidIndexRoute: typeof BuyerOrdersOrderidIndexRoute
}

const BuyerRouteChildren: BuyerRouteChildren = {
  BuyerDisputeRoute: BuyerDisputeRouteWithChildren,
  BuyerHomeRoute: BuyerHomeRoute,
  BuyerNotificationsRoute: BuyerNotificationsRoute,
  BuyerSupportRoute: BuyerSupportRoute,
  BuyerSettingsMyAccountRoute: BuyerSettingsMyAccountRoute,
  BuyerVendorVendoridRoute: BuyerVendorVendoridRoute,
  BuyerOrdersIndexRoute: BuyerOrdersIndexRoute,
  BuyerSettingsIndexRoute: BuyerSettingsIndexRoute,
  BuyerVendorIndexRoute: BuyerVendorIndexRoute,
  BuyerOrdersOrderidChatRoute: BuyerOrdersOrderidChatRoute,
  BuyerOrdersOrderidIndexRoute: BuyerOrdersOrderidIndexRoute,
}

const BuyerRouteWithChildren = BuyerRoute._addFileChildren(BuyerRouteChildren)

interface VendorDisputeRouteChildren {
  VendorDisputeDisputeidRoute: typeof VendorDisputeDisputeidRoute
}

const VendorDisputeRouteChildren: VendorDisputeRouteChildren = {
  VendorDisputeDisputeidRoute: VendorDisputeDisputeidRoute,
}

const VendorDisputeRouteWithChildren = VendorDisputeRoute._addFileChildren(
  VendorDisputeRouteChildren,
)

interface VendorRouteChildren {
  VendorDisputeRoute: typeof VendorDisputeRouteWithChildren
  VendorHomeRoute: typeof VendorHomeRoute
  VendorNotificationsRoute: typeof VendorNotificationsRoute
  VendorSupportRoute: typeof VendorSupportRoute
  VendorContractCartRoute: typeof VendorContractCartRoute
  VendorContractCreateRoute: typeof VendorContractCreateRoute
  VendorContractDropoffLocationRoute: typeof VendorContractDropoffLocationRoute
  VendorOrdersOrderidRoute: typeof VendorOrdersOrderidRoute
  VendorStoreProductidRoute: typeof VendorStoreProductidRoute
  VendorStoreCreateRoute: typeof VendorStoreCreateRoute
  VendorContractIndexRoute: typeof VendorContractIndexRoute
  VendorOrdersIndexRoute: typeof VendorOrdersIndexRoute
  VendorSettingsIndexRoute: typeof VendorSettingsIndexRoute
  VendorStoreIndexRoute: typeof VendorStoreIndexRoute
  VendorContractContractidEditRoute: typeof VendorContractContractidEditRoute
  VendorStoreEditProductidRoute: typeof VendorStoreEditProductidRoute
  VendorContractContractidIndexRoute: typeof VendorContractContractidIndexRoute
}

const VendorRouteChildren: VendorRouteChildren = {
  VendorDisputeRoute: VendorDisputeRouteWithChildren,
  VendorHomeRoute: VendorHomeRoute,
  VendorNotificationsRoute: VendorNotificationsRoute,
  VendorSupportRoute: VendorSupportRoute,
  VendorContractCartRoute: VendorContractCartRoute,
  VendorContractCreateRoute: VendorContractCreateRoute,
  VendorContractDropoffLocationRoute: VendorContractDropoffLocationRoute,
  VendorOrdersOrderidRoute: VendorOrdersOrderidRoute,
  VendorStoreProductidRoute: VendorStoreProductidRoute,
  VendorStoreCreateRoute: VendorStoreCreateRoute,
  VendorContractIndexRoute: VendorContractIndexRoute,
  VendorOrdersIndexRoute: VendorOrdersIndexRoute,
  VendorSettingsIndexRoute: VendorSettingsIndexRoute,
  VendorStoreIndexRoute: VendorStoreIndexRoute,
  VendorContractContractidEditRoute: VendorContractContractidEditRoute,
  VendorStoreEditProductidRoute: VendorStoreEditProductidRoute,
  VendorContractContractidIndexRoute: VendorContractContractidIndexRoute,
}

const VendorRouteWithChildren =
  VendorRoute._addFileChildren(VendorRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/buyer': typeof BuyerRouteWithChildren
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/user-type': typeof AuthUserTypeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/orders': typeof BuyerOrdersIndexRoute
  '/buyer/settings': typeof BuyerSettingsIndexRoute
  '/buyer/vendor': typeof BuyerVendorIndexRoute
  '/vendor/contract': typeof VendorContractIndexRoute
  '/vendor/orders': typeof VendorOrdersIndexRoute
  '/vendor/settings': typeof VendorSettingsIndexRoute
  '/vendor/store': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid': typeof VendorContractContractidIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthRouteWithChildren
  '/buyer': typeof BuyerRouteWithChildren
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/sign-in': typeof AuthSignInRoute
  '/sign-up': typeof AuthSignUpRoute
  '/user-type': typeof AuthUserTypeRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/orders': typeof BuyerOrdersIndexRoute
  '/buyer/settings': typeof BuyerSettingsIndexRoute
  '/buyer/vendor': typeof BuyerVendorIndexRoute
  '/vendor/contract': typeof VendorContractIndexRoute
  '/vendor/orders': typeof VendorOrdersIndexRoute
  '/vendor/settings': typeof VendorSettingsIndexRoute
  '/vendor/store': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid': typeof VendorContractContractidIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/buyer': typeof BuyerRouteWithChildren
  '/form': typeof FormRoute
  '/get-started': typeof GetStartedRoute
  '/policy': typeof PolicyRoute
  '/privacy': typeof PrivacyRoute
  '/query': typeof QueryRoute
  '/terms': typeof TermsRoute
  '/test-payment': typeof TestPaymentRoute
  '/vendor': typeof VendorRouteWithChildren
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/_auth/user-type': typeof AuthUserTypeRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/buyer/dispute': typeof BuyerDisputeRouteWithChildren
  '/buyer/home': typeof BuyerHomeRoute
  '/buyer/notifications': typeof BuyerNotificationsRoute
  '/buyer/support': typeof BuyerSupportRoute
  '/vendor/dispute': typeof VendorDisputeRouteWithChildren
  '/vendor/home': typeof VendorHomeRoute
  '/vendor/notifications': typeof VendorNotificationsRoute
  '/vendor/support': typeof VendorSupportRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordLazyRoute
  '/buyer/dispute/$disputeid': typeof BuyerDisputeDisputeidRoute
  '/buyer/settings/my-account': typeof BuyerSettingsMyAccountRoute
  '/buyer/vendor/$vendorid': typeof BuyerVendorVendoridRoute
  '/vendor/contract/cart': typeof VendorContractCartRoute
  '/vendor/contract/create': typeof VendorContractCreateRoute
  '/vendor/contract/dropoff-location': typeof VendorContractDropoffLocationRoute
  '/vendor/dispute/$disputeid': typeof VendorDisputeDisputeidRoute
  '/vendor/orders/$orderid': typeof VendorOrdersOrderidRoute
  '/vendor/store/$productid': typeof VendorStoreProductidRoute
  '/vendor/store/create': typeof VendorStoreCreateRoute
  '/buyer/orders/': typeof BuyerOrdersIndexRoute
  '/buyer/settings/': typeof BuyerSettingsIndexRoute
  '/buyer/vendor/': typeof BuyerVendorIndexRoute
  '/vendor/contract/': typeof VendorContractIndexRoute
  '/vendor/orders/': typeof VendorOrdersIndexRoute
  '/vendor/settings/': typeof VendorSettingsIndexRoute
  '/vendor/store/': typeof VendorStoreIndexRoute
  '/buyer/orders/$orderid/chat': typeof BuyerOrdersOrderidChatRoute
  '/vendor/contract/$contractid/edit': typeof VendorContractContractidEditRoute
  '/vendor/store/edit/$productid': typeof VendorStoreEditProductidRoute
  '/buyer/orders/$orderid/': typeof BuyerOrdersOrderidIndexRoute
  '/vendor/contract/$contractid/': typeof VendorContractContractidIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/buyer'
    | '/form'
    | '/get-started'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/sign-in'
    | '/sign-up'
    | '/user-type'
    | '/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/forgot-password'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/orders'
    | '/buyer/settings'
    | '/buyer/vendor'
    | '/vendor/contract'
    | '/vendor/orders'
    | '/vendor/settings'
    | '/vendor/store'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid'
    | '/vendor/contract/$contractid'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/buyer'
    | '/form'
    | '/get-started'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/sign-in'
    | '/sign-up'
    | '/user-type'
    | '/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/forgot-password'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/orders'
    | '/buyer/settings'
    | '/buyer/vendor'
    | '/vendor/contract'
    | '/vendor/orders'
    | '/vendor/settings'
    | '/vendor/store'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid'
    | '/vendor/contract/$contractid'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/buyer'
    | '/form'
    | '/get-started'
    | '/policy'
    | '/privacy'
    | '/query'
    | '/terms'
    | '/test-payment'
    | '/vendor'
    | '/_auth/sign-in'
    | '/_auth/sign-up'
    | '/_auth/user-type'
    | '/_auth/verify-email'
    | '/buyer/dispute'
    | '/buyer/home'
    | '/buyer/notifications'
    | '/buyer/support'
    | '/vendor/dispute'
    | '/vendor/home'
    | '/vendor/notifications'
    | '/vendor/support'
    | '/_auth/forgot-password'
    | '/buyer/dispute/$disputeid'
    | '/buyer/settings/my-account'
    | '/buyer/vendor/$vendorid'
    | '/vendor/contract/cart'
    | '/vendor/contract/create'
    | '/vendor/contract/dropoff-location'
    | '/vendor/dispute/$disputeid'
    | '/vendor/orders/$orderid'
    | '/vendor/store/$productid'
    | '/vendor/store/create'
    | '/buyer/orders/'
    | '/buyer/settings/'
    | '/buyer/vendor/'
    | '/vendor/contract/'
    | '/vendor/orders/'
    | '/vendor/settings/'
    | '/vendor/store/'
    | '/buyer/orders/$orderid/chat'
    | '/vendor/contract/$contractid/edit'
    | '/vendor/store/edit/$productid'
    | '/buyer/orders/$orderid/'
    | '/vendor/contract/$contractid/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  BuyerRoute: typeof BuyerRouteWithChildren
  FormRoute: typeof FormRoute
  GetStartedRoute: typeof GetStartedRoute
  PolicyRoute: typeof PolicyRoute
  PrivacyRoute: typeof PrivacyRoute
  QueryRoute: typeof QueryRoute
  TermsRoute: typeof TermsRoute
  TestPaymentRoute: typeof TestPaymentRoute
  VendorRoute: typeof VendorRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  BuyerRoute: BuyerRouteWithChildren,
  FormRoute: FormRoute,
  GetStartedRoute: GetStartedRoute,
  PolicyRoute: PolicyRoute,
  PrivacyRoute: PrivacyRoute,
  QueryRoute: QueryRoute,
  TermsRoute: TermsRoute,
  TestPaymentRoute: TestPaymentRoute,
  VendorRoute: VendorRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_auth",
        "/buyer",
        "/form",
        "/get-started",
        "/policy",
        "/privacy",
        "/query",
        "/terms",
        "/test-payment",
        "/vendor"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/sign-in",
        "/_auth/sign-up",
        "/_auth/user-type",
        "/_auth/verify-email",
        "/_auth/forgot-password"
      ]
    },
    "/buyer": {
      "filePath": "buyer.tsx",
      "children": [
        "/buyer/dispute",
        "/buyer/home",
        "/buyer/notifications",
        "/buyer/support",
        "/buyer/settings/my-account",
        "/buyer/vendor/$vendorid",
        "/buyer/orders/",
        "/buyer/settings/",
        "/buyer/vendor/",
        "/buyer/orders/$orderid/chat",
        "/buyer/orders/$orderid/"
      ]
    },
    "/form": {
      "filePath": "form.tsx"
    },
    "/get-started": {
      "filePath": "get-started.tsx"
    },
    "/policy": {
      "filePath": "policy.tsx"
    },
    "/privacy": {
      "filePath": "privacy.tsx"
    },
    "/query": {
      "filePath": "query.tsx"
    },
    "/terms": {
      "filePath": "terms.tsx"
    },
    "/test-payment": {
      "filePath": "test-payment.tsx"
    },
    "/vendor": {
      "filePath": "vendor.tsx",
      "children": [
        "/vendor/dispute",
        "/vendor/home",
        "/vendor/notifications",
        "/vendor/support",
        "/vendor/contract/cart",
        "/vendor/contract/create",
        "/vendor/contract/dropoff-location",
        "/vendor/orders/$orderid",
        "/vendor/store/$productid",
        "/vendor/store/create",
        "/vendor/contract/",
        "/vendor/orders/",
        "/vendor/settings/",
        "/vendor/store/",
        "/vendor/contract/$contractid/edit",
        "/vendor/store/edit/$productid",
        "/vendor/contract/$contractid/"
      ]
    },
    "/_auth/sign-in": {
      "filePath": "_auth/sign-in.tsx",
      "parent": "/_auth"
    },
    "/_auth/sign-up": {
      "filePath": "_auth/sign-up.tsx",
      "parent": "/_auth"
    },
    "/_auth/user-type": {
      "filePath": "_auth/user-type.tsx",
      "parent": "/_auth"
    },
    "/_auth/verify-email": {
      "filePath": "_auth/verify-email.tsx",
      "parent": "/_auth"
    },
    "/buyer/dispute": {
      "filePath": "buyer/dispute.tsx",
      "parent": "/buyer",
      "children": [
        "/buyer/dispute/$disputeid"
      ]
    },
    "/buyer/home": {
      "filePath": "buyer/home.tsx",
      "parent": "/buyer"
    },
    "/buyer/notifications": {
      "filePath": "buyer/notifications.tsx",
      "parent": "/buyer"
    },
    "/buyer/support": {
      "filePath": "buyer/support.tsx",
      "parent": "/buyer"
    },
    "/vendor/dispute": {
      "filePath": "vendor/dispute.tsx",
      "parent": "/vendor",
      "children": [
        "/vendor/dispute/$disputeid"
      ]
    },
    "/vendor/home": {
      "filePath": "vendor/home.tsx",
      "parent": "/vendor"
    },
    "/vendor/notifications": {
      "filePath": "vendor/notifications.tsx",
      "parent": "/vendor"
    },
    "/vendor/support": {
      "filePath": "vendor/support.tsx",
      "parent": "/vendor"
    },
    "/_auth/forgot-password": {
      "filePath": "_auth/forgot-password.lazy.tsx",
      "parent": "/_auth"
    },
    "/buyer/dispute/$disputeid": {
      "filePath": "buyer/dispute/$disputeid.tsx",
      "parent": "/buyer/dispute"
    },
    "/buyer/settings/my-account": {
      "filePath": "buyer/settings/my-account.tsx",
      "parent": "/buyer"
    },
    "/buyer/vendor/$vendorid": {
      "filePath": "buyer/vendor/$vendorid.tsx",
      "parent": "/buyer"
    },
    "/vendor/contract/cart": {
      "filePath": "vendor/contract/cart.tsx",
      "parent": "/vendor"
    },
    "/vendor/contract/create": {
      "filePath": "vendor/contract/create.tsx",
      "parent": "/vendor"
    },
    "/vendor/contract/dropoff-location": {
      "filePath": "vendor/contract/dropoff-location.tsx",
      "parent": "/vendor"
    },
    "/vendor/dispute/$disputeid": {
      "filePath": "vendor/dispute/$disputeid.tsx",
      "parent": "/vendor/dispute"
    },
    "/vendor/orders/$orderid": {
      "filePath": "vendor/orders/$orderid.tsx",
      "parent": "/vendor"
    },
    "/vendor/store/$productid": {
      "filePath": "vendor/store/$productid.tsx",
      "parent": "/vendor"
    },
    "/vendor/store/create": {
      "filePath": "vendor/store/create.tsx",
      "parent": "/vendor"
    },
    "/buyer/orders/": {
      "filePath": "buyer/orders/index.tsx",
      "parent": "/buyer"
    },
    "/buyer/settings/": {
      "filePath": "buyer/settings/index.tsx",
      "parent": "/buyer"
    },
    "/buyer/vendor/": {
      "filePath": "buyer/vendor/index.tsx",
      "parent": "/buyer"
    },
    "/vendor/contract/": {
      "filePath": "vendor/contract/index.tsx",
      "parent": "/vendor"
    },
    "/vendor/orders/": {
      "filePath": "vendor/orders/index.tsx",
      "parent": "/vendor"
    },
    "/vendor/settings/": {
      "filePath": "vendor/settings/index.tsx",
      "parent": "/vendor"
    },
    "/vendor/store/": {
      "filePath": "vendor/store/index.tsx",
      "parent": "/vendor"
    },
    "/buyer/orders/$orderid/chat": {
      "filePath": "buyer/orders/$orderid/chat.tsx",
      "parent": "/buyer"
    },
    "/vendor/contract/$contractid/edit": {
      "filePath": "vendor/contract/$contractid/edit.tsx",
      "parent": "/vendor"
    },
    "/vendor/store/edit/$productid": {
      "filePath": "vendor/store/edit.$productid.tsx",
      "parent": "/vendor"
    },
    "/buyer/orders/$orderid/": {
      "filePath": "buyer/orders/$orderid/index.tsx",
      "parent": "/buyer"
    },
    "/vendor/contract/$contractid/": {
      "filePath": "vendor/contract/$contractid/index.tsx",
      "parent": "/vendor"
    }
  }
}
ROUTE_MANIFEST_END */
